import UIComponent from "../ui/component";

export class PreloaderCarousel extends UIComponent {
    init() {
        this.slides = this.findAll('.slide');

        this.currentIndex = 0;
        this.autoSwitchInterval = 5000;

        this.createIndicators();
        this.showSlide(this.currentIndex);

        this.startAutoSwitch();
    }

    createIndicators() {
        this.indicatorsContainer.element.innerHTML = '';
        this.indicators = [];

        this.slides.forEach((_, index) => {
            const indicator = document.createElement('div');
            indicator.classList.add(index === 0 ? 'slider-active' : 'slider-noactive');
            indicator.addEventListener('click', () => {
                this.showSlide(index);
                this.resetAutoSwitch();
            });
            this.indicatorsContainer.element.appendChild(indicator);
            this.indicators.push(indicator);
        });
    }

    showSlide(index) {
        this.slides.forEach(slide => slide.classList.remove('active-slide'));
        this.indicators.forEach(ind => {
            ind.classList.remove('slider-active');
            ind.classList.add('slider-noactive');
        });

        this.slides[index].classList.add('active-slide');
        this.indicators[index].classList.add('slider-active');
        this.indicators[index].classList.remove('slider-noactive');

        this.currentIndex = index;
    }

    startAutoSwitch() {
        this.intervalId = setInterval(() => {
            let nextIndex = (this.currentIndex + 1) % this.slides.length;
            this.showSlide(nextIndex);
        }, this.autoSwitchInterval);
    }

    resetAutoSwitch() {
        clearInterval(this.intervalId);
        this.startAutoSwitch();
    }
}
